import React from 'react';

import paths from 'config/paths';

import LabeledIconLink from '../labeled-icon-link';

const PhoneGuestIcons = () => (
  <>
    <LabeledIconLink path={paths.login} intlId="header.log_in" iconClassName="header__log-in-mobile-icon" />
    <LabeledIconLink path={paths.register} intlId="header.sign_up" iconClassName="header__sign-up-mobile-icon" />
  </>
);

export default PhoneGuestIcons;
